<template>
  <!-- content -->
  <div class="board_write_wrap">
    <div class="board_write">
      <div class="write_title">
        <label class="">제목입력</label>
        <input type="text" class="title" v-model="title" maxlength="30" autofocus autocomplete="off" />
      </div>
      <div class="write_title">
        <div>
          <label class="write_writer">이름 / 회사명 </label>
          <input type="text" class="writer" maxlength="10" id="" v-model="writer" autofocus autocomplete="off" placeholder="글쓴이 " />
        </div>
      </div>
      <div class="write">
        <div class="write_email">
          <label class="">이메일 </label>
          <input type="text" class="email" v-model="email" @change="checkEmail()" autofocus autocomplete="off" placeholder="abc@naver.com" />
        </div>
        <div class="write_num">
          <label class="">전화번호 </label>
          <input type="text" class="tel" v-model="tel" v-on:input="checkTel(tel)" autocomplete="off" maxlength="13" placeholder="010-0000-0000" />
        </div>
      </div>

      <div class="write_content">
        <label class="">상담 받을 내용</label>
        <textarea class="contents" v-model="contents" autofocus autocomplete="off" placeholder="상담 받으실 내용을 작성해 주세요."></textarea>
      </div>
      <ul class="password">
        <li class="round">
          <input type="checkbox" id="checkbox" v-model="check" @click="oncheck()" />
          <label for="checkbox" class="check_hide">비공개</label>
        </li>
        <li>
          <label class="" style="width: 100px"> 비밀번호<a style="color: red">*</a> </label>
          <input type="text" class="" maxlength="4" v-model="password" @change="checkPassword()" autofocus autocomplete="off" placeholder="비밀번호(숫자) " /><a
            style="font-size: 12px; color: red; padding-left: 20px"
            >비밀번호를 입력해 주세요.</a
          >
        </li>
      </ul>

      <div class="board_btn">
        <button v-if="this.$route.query.id == null || this.$route.query.id == ''" @click="onView()" class="bnt_register">등록</button>
        <button v-if="this.$route.query.id > 0" @click="onModify()" class="btn_modify">수정</button>
        <router-link :to="{ name: 'list' }" class="bnt_cancel" type="button">취소</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  data() {
    return {
      id: 0,
      title: '',
      writer: '',
      date: '',
      count: 0,
      email: '',
      tel: '',
      contents: '',
      password: '',
      check: false,
      checking: '',
    }
  },
  created() {
    if (this.$route.query.id > 0) {
      axios
        .get('/api/consult/getOne/' + this.$route.query.id)
        .then((res) => {
          this.writer = res.data[0].writer
          this.password = res.data[0].password
          this.email = res.data[0].email
          this.tel = res.data[0].tel
          this.title = res.data[0].title
          this.contents = res.data[0].contents
          this.count = res.data[0].count
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },

  methods: {
    onPost(checking) {
      console.log(checking)
      axios
        .all([
          axios({
            url: '/api/consult/postList',
            method: 'POST',
            data: {
              title: this.title,
              writer: this.writer,
              email: this.email,
              tel: this.tel,
              contents: this.contents,
              password: this.password,
              count: this.count,
              checking: checking,
            },
          }),
          axios({
            url: '/api/mail',
            method: 'POST',
            data: {
              title: this.title,
              writer: this.writer,
              email: this.email,
              tel: this.tel,
              contents: this.contents,
            },
          }),
        ])
        .then((res) => {
          // if (res.data.success == true) {
          // }
        })
        .catch((err) => {
          alert(err)
        })
    },
    onView() {
      if (this.password == null || this.password == '') {
        alert('비밀번호를 입력해 주세요.')
      } else {
        if (this.check == false) {
          this.checking = 'N'
          this.onPost(this.checking)
        } else {
          this.onPost(this.checking)
        }

        this.$router.push('/consult/consultAsk/')
      }
    },
    onModify() {
      axios({
        url: '/api/consult/update',
        method: 'POST',
        data: {
          id: this.$route.query.id,
          title: this.title,
          writer: this.writer,
          email: this.email,
          tel: this.tel,
          contents: this.contents,
          password: this.password,
          count: this.count,
          checking: this.checking,
        },
      })
        .then((res) => {
          // if (res.data.success == true) {
          // }
        })
        .catch((err) => {
          alert(err)
        })
      this.$router.push('/consult/consultAsk/')
    },
    oncheck() {
      if (this.check == true) {
        this.checking = 'N'
        // console.log(this.checking)
      } else {
        this.checking = 'Y'
        // console.log(this.checking)
      }
    },
    checkTel: function (target) {
      if (target.length == 13) {
        this.tel = target
          .replace(/[^0-9]/g, '')
          .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, '$1-$2-$3')
          .replace(/(\-{1,2})$/g, '')
      } else if (target.length == 12) {
        this.tel = target
          .replace(/[^0-9]/g, '')
          .replace(/^(\d{0,2})(\d{0,4})(\d{0,4})$/g, '$1-$2-$3')
          .replace(/(\-{1,2})$/g, '')
      } else {
        this.tel = target
          .replace(/[^0-9]/g, '')
          .replace(/^(\d{0,2})(\d{0,3})(\d{0,4})$/g, '$1-$2-$3')
          .replace(/(\-{1,2})$/g, '')
      }
    },
    checkEmail() {
      var pattern = /^[A-Za-z0-9_\\.\\-]+@[A-Za-z0-9\\-]+\.[A-Za-z0-9\\-]+/
      if (!pattern.test(this.email) || !this.email) {
        return alert('이메일 형식이 올바르지 않습니다..')
      } else {
        return true
      }
    },
    checkPassword() {
      var pattern = /^(?=.*[0-9]).{4,4}$/
      if (!pattern.test(this.password) || !this.password) {
        return alert('비밀번호 형식을 다시 확인해 주세요.')
      } else {
        return true
      }
    },
  },
}
</script>

<style scoped>
@import '@/style/board.css';
@import '@/style/checkbox.css';
.password {
  display: flex;
  align-content: center;
}
.board_write .password > li {
  display: inline-block;
}
.password .check_hide {
  width: 80px;
  padding-left: 10px;
  vertical-align: top;
}
</style>
